import { Component, Input, OnInit } from '@angular/core';
import { Store } from '@ngrx/store';
import { take } from 'rxjs';
import {
	InvestmentSettings,
	ReturnOfInvestmentSimulator,
} from 'src/app/models/investment/investment.model';
import { InvestmentService } from 'src/app/services/apis/investment/investment.service';
import { PreApplicationActions } from 'src/app/state/actions/pre-application.actions';
import { selectProductInfo } from 'src/app/state/selectors/pre-application.selectors';

@Component({
	selector: 'cmv-simulator-container',
	templateUrl: './simulator-container.component.html',
	styleUrls: ['./simulator-container.component.scss'],
})
export class SimulatorContainerComponent implements OnInit {
	@Input() minimumAmount: number = 15000;
	@Input() maximumAmount: number = 9_999_999;
	@Input() step: number = 1_000;
	maxRate: number = 13.0;
	canLoadData: boolean;
	jump: number = 100;
	@Input()
	set loadData(canLoadData: boolean) {
		this.canLoadData = canLoadData;
		if (canLoadData) {
			this.getProductIdAndGetReturnOfInvesment();
		}
	}
	amountToInvest: number = 15000;
	returnOfInvesmentResults: Array<ReturnOfInvestmentSimulator> = [];
	investmentSettings: Array<InvestmentSettings> = [];
	isGettingReturnOfInvestment: boolean = false;

	constructor(
		private investmentService: InvestmentService,
		private store: Store
	) {}
	ngOnInit(): void {
		this.returnOfInvesmentResults =
			this.investmentService.calculateAllReturnOfInvest(
				this.investmentService.defaultInvestmentSettings,
				0
			);
	}

	onCalculateReturnOfInvesment(): void {
		if (this.isAmountToInvestLowerThanMinimum) {
			return;
		}
		this.getProductIdAndGetReturnOfInvesment();
	}

	get isAmountToInvestLowerThanMinimum() {
		return this.amountToInvest < this.minimumAmount;
	}

	get jumpAmount(): number {
		if (this.amountToInvest >= 100_000) {
			return 10_000;
		}

		if (this.amountToInvest >= 60_000) {
			return 5_000;
		}

		if (this.amountToInvest >= 30_000) {
			return 2_500;
		}

		return this.jump;
	}

	onManualAmountChange(newAmountSelected: number) {
		if (!this.canLoadData) {
			return;
		}

		if (newAmountSelected < this.minimumAmount) {
			this.amountToInvest = newAmountSelected;
			this.returnOfInvesmentResults = this.calculateReturnOfInvestment(0);
			return;
		}

		this.amountToInvest =
			newAmountSelected <= this.maximumAmount
				? newAmountSelected
				: this.maximumAmount;

		this.returnOfInvesmentResults = this.calculateReturnOfInvestment(
			this.amountToInvest
		);
	}

	private calculateReturnOfInvestment(
		amountToInvest: number
	): Array<ReturnOfInvestmentSimulator> {
		return this.investmentService.calculateAllReturnOfInvest(
			this.investmentSettings,
			amountToInvest
		);
	}

	private getProductIdAndGetReturnOfInvesment() {
		this.store
			.select(selectProductInfo)
			.pipe(take(1))
			.subscribe(productInfo => {
				this.getReturnOfInvestmentBy(
					this.amountToInvest,
					productInfo.productName.toUpperCase()
				);
			});
	}

	private getReturnOfInvestmentBy(amount: number, productName: string): void {
		this.startGettingReturnOfInvestment();
		this.investmentService
			.getReturnOfInvestment(amount, productName)
			.subscribe({
				next: response => {
					this.stopGettingReturnOfInvestment();

					this.investmentSettings = response.map(rendimiento => ({
						rate: rendimiento.Tasa,
						period: rendimiento.Plazo,
					}));

					this.returnOfInvesmentResults =
						this.investmentService.calculateAllReturnOfInvest(
							this.investmentSettings,
							amount
						);

					this.maxRate = response.reduce((prev, current) =>
						prev.Tasa > current.Tasa ? prev : current
					).Tasa;

					this.store.dispatch(
						PreApplicationActions.addAmountFromInvestementSimulator({ amount })
					);
				},
				error: (error: Error) => {
					this.stopGettingReturnOfInvestment();
					console.log(
						'🚀 ~ file: simulator-container.component.ts:81 ~ SimulatorContainerComponent ~ getReturnOfInvesmentBy ~ error:',
						error
					);
				},
			});
	}

	private startGettingReturnOfInvestment(): void {
		this.isGettingReturnOfInvestment = true;
	}

	private stopGettingReturnOfInvestment(): void {
		this.isGettingReturnOfInvestment = false;
	}
}
